import { httpService } from './HttpService';
import { EstadisticaPersonalizadaQuery } from '@/model/EstadisticaPersonalizadaQuery';
import { EstadisticaComparativaHistoricoTotalDia } from '@/model/EstadisticaComparativaHistoricoTotalDia';
import { EstadisticaTotal } from '@/model/EstadisticaTotal';
import { EstadisticaPersonalizada } from '@/model/EstadisticaPersonalizada';
import { EstadisticasGlobalesSorteo } from '@/model/EstadisticasGlobalesSorteo';

export class EstadisticasService {
    entity: string = "Estadisticas"
    constructor(){
    }

    CalcularComparativoHistorico(idSorteoPrimero: number, idSorteoSegundo: number): Promise<Array<EstadisticaComparativaHistoricoTotalDia>> {
        return httpService.get(this.entity+"/CalcularComparativoHistorico/"+idSorteoPrimero+"/"+idSorteoSegundo);
    }

    CalcularEstadisticaPersonalizada(query: EstadisticaPersonalizadaQuery): Promise<EstadisticaPersonalizada> {
        return httpService.post(this.entity+"/CalcularEstadisticaPersonalizada", query);
    }

    CalcularEstadisticasGlobalesSorteo(idSorteo: number): Promise<EstadisticasGlobalesSorteo> {
        return httpService.get(this.entity+"/CalcularEstadisticasGlobalesSorteo/"+idSorteo);
    }

    CalcularEstadisticaTotal(idSorteo: number): Promise<Array<EstadisticaTotal>> {
        return httpService.get(this.entity+"/CalcularEstadisticaTotal/"+idSorteo);
    }
}